import {get, complete, start, saveProgress, rate} from '../models/Meditation';

const getMeditation = (caller, payload) => {
    return {
        type: "GET_MEDITATION",
        payload: get(caller, payload)
    }
};

const getMeditations = (caller) => {
    return {
        type: "GET_MEDITATIONS",
        payload: get(caller)
    }
};

const completeMeditation = (caller, payload) => {
    return {
        type: "COMPLETE_MEDITATION",
        payload: complete(caller, payload)
    }
};

const startMeditation = (caller, payload) => {
    return {
        type: "START_MEDITATION",
        payload: start(caller, payload)
    }
};

const progressMeditation = (caller, payload) => {
    return {
        type: "PROGRESS_MEDITATION",
        payload: saveProgress(caller, payload)
    }
};

const rateMeditation = (caller, payload) => {
    return {
        type: "RATE_MEDITATION",
        payload: rate(caller, payload)
    }
};

const playMeditation = (payload) => {
    return {
        type: "PLAY_MEDITATION",
        payload: payload
    }
};

const pauseMeditation = (payload) => {
    return {
        type: "PAUSE_MEDITATION",
        payload: payload
    }
};

export {getMeditation, getMeditations, completeMeditation,
    startMeditation, progressMeditation, rateMeditation,
    playMeditation, pauseMeditation};


// WEBPACK FOOTER //
// ./src/actions/Meditation.js